import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    success: false,
    data: {
        leadAcademyUrl: '',
    },
};

const leadAcademySlice = createSlice({
    name: 'leadAcademy',
    initialState,
    reducers: {
        setLeadAcademyData: (state, action) => {
            state.success = action.payload.success;
            state.data.leadAcademyUrl = action.payload.data.leadAcademyUrl;
        },
    },
});

export const { setLeadAcademyData } = leadAcademySlice.actions;

export default leadAcademySlice.reducer;
